import * as React from 'react';
import { clsx } from 'clsx';
import { IconSuccess16, UIText1 } from '@cian/ui-kit';

import * as styles from './MapRows.css';

export interface IMapRowsProps {
  items: Array<{
    id: string;
    text: string;
    IconComponent: React.FunctionComponent;
  }>;
  onRowClick?: (rowId: string) => void;
  selectedItemId?: string;
  hasHover?: boolean;
}

export const MapRows: React.FC<IMapRowsProps> = ({ items, onRowClick, selectedItemId, hasHover = true }) => {
  const handleRowClick = React.useCallback(
    (rowId: string) => {
      if (onRowClick) {
        onRowClick(rowId);
      }
    },
    [onRowClick],
  );

  return (
    <>
      {items.map(item => {
        const { IconComponent, id, text } = item;

        return (
          <div
            key={id}
            className={clsx(styles['row'], hasHover && styles['hasHover'])}
            role="button"
            onClick={() => handleRowClick(id)}
          >
            <IconComponent />
            <div className={styles['text']}>
              <UIText1>{text}</UIText1>
              {selectedItemId === id && (
                <div className={styles['success-icon-wrapper']}>
                  <IconSuccess16 color="primary_100" />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};
